export enum AuthTypes {
  HANDSHAKE = 'handshake',
  KEYCLOAK = 'keycloak',
}
